import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const updateRecruitmentSlice = createSlice({
  name: "updateRecruitment",
  initialState,
  reducers: {
    updateRecruitmentStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    updateRecruitmentSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateRecruitmentFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateRecruitmentStart,
  updateRecruitmentSuccess,
  updateRecruitmentFailed,
} = updateRecruitmentSlice.actions;

export default updateRecruitmentSlice.reducer;
